var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeNotice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "46px",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / badge_notice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-badge_notice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A7ACB0",
    strokeWidth: 0,
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "notice",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#0F2B41",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(3.571429, 3.571429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.015873,9.55404762 C23.015873,14.7393651 17.8638889,18.9429365 11.5079365,18.9429365 C10.0896825,18.9429365 8.79444444,18.6369841 7.53968254,18.2540476 L0.863095238,21.4286508 L3.57142857,16.2699206 C1.44126984,14.5655556 0,12.1806349 0,9.55404762 C0,4.36873016 5.15198413,7.93650794e-05 11.5079365,7.93650794e-05 C17.8638889,7.93650794e-05 23.015873,4.36873016 23.015873,9.55404762 Z",
    id: "Stroke-1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00488095,6.03174603 L13.509246,6.03174603",
    id: "Stroke-3",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00488095,9.20634921 L16.511627,9.20634921",
    id: "Stroke-5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00488095,12.3809524 L16.511627,12.3809524",
    id: "Stroke-7",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeNotice);
export default __webpack_public_path__ + "static/media/badgeNotice.d5820c9687e079eb6f0f15522f61e903.svg";
export { ForwardRef as ReactComponent };